// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1uwOX","label":"Radio_label__Sdnzf","checkMark":"Radio_checkMark__koxtC","disabled":"Radio_disabled__1NTk2"};